<template>
  <Modal
    :width="623"
    :visible="previewVisible"
    title="AI续写"
    okText="续写文章"
    @cancel="previewVisible = false"
    @ok="onSubmit"
  >
    <div class="model-content">
      <div class="article flex-column">
        <div class="flex">
          <div style="width: 100px; text-align: right">上文：</div>
          <div class="flex1">{{ content }}</div>
        </div>
        <div class="flex" style="margin-top: 30px">
          <div class="x-end" style="width: 100px; text-align: right" @click="onContinue">
            <img
              v-if="loading"
              class="rotate"
              src="@/assets/images/icon_loading@2x.png"
              style="width: 16px; height: 16px; margin-right: 8px"
            />
            <img
              v-else
              src="@/assets/images/pop_aixuxie@2x.png"
              style="width: 16px; height: 16px; margin-right: 8px"
            />
            <span>AI续写：</span>
          </div>
          <div class="flex1">{{ text }}</div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="x-end">
        <Button class="button none" @click="previewVisible = false">取消</Button>
        <Button class="button" v-if="!loading" type="primary" @click="onSubmit">续写文章</Button>
      </div>
     <!-- <div class="x-end">
         <div class="tips"
          ><span style="color: #f53131">*</span>消耗{{ imagineNum.ai_word }}想象栗，当前剩余{{
            imagineNum.imagine_num
          }}想象栗</div
        >
      </div> -->
    </template>
  </Modal>
</template>

<script>
  import { Modal, Button } from 'ant-design-vue';
  import defHttp from '@/jslibs/axios/http';

  export default {
    name: 'AIContinue',
    components: {
      Modal,
      Button,
    },
    props: {
      content: String,
    },
    data() {
      return {
        imagineNum: {},
        previewVisible: false,
        loading: false,
        text: '',
      };
    },
    methods: {
      onShow() {
        this.previewVisible = true;
        this.$nextTick(() => {
          this.text = ''
          this.onContinue();
        });
        // this.getImagineNum();
      },
      onHide() {
        this.previewVisible = false;
      },
      onContinue() {
        console.log(23)
        if (this.loading) return false;
        this.loading = true;
        defHttp
          .post( `/cms/AiContent/continueContent`, {
              content: this.content,
            })
          .then((res) => {
            console.log(res)
            this.loading = false;
            this.text = res.data.result;
            // this.getImagineNum();
          })
          .catch(() => {
            this.loading = false;
          });
      },
      getImagineNum() {
        // defHttp
        //   .get({
        //     url: `/v1/cms/GetImagineNum`,
        //   })
        //   .then((res) => {
        //     this.imagineNum = res.result;
        //   });
      },
      onSubmit() {
        this.$emit('onAiContinue', `<br /><br />${this.text}`);
        this.onHide()
      },
    },
  };
</script>

<style lang="less" scoped>
  .model-content {
    padding: 24px;
  }

  .article {
    padding: 20px 30px;
    color: #222;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;

    .nav-item {
      min-width: 90px;
      height: 32px;
      margin-right: 12px;
      padding: 0 10px;
      border-radius: 3px;
      background: #f6f6f6;
      color: #000;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      cursor: pointer;

      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }

      &.active {
        border: 1px solid #000;
        background: #7472f6;
      }
    }
  }

  .tips {
    margin-top: 10px;
    color: #999;
    font-size: 12px;
    font-weight: 400;
  }
</style>
